import i18n from '../i18n';
import { getLocalized } from '../i18n/getLocalized';

/**
 * Field schemas store every user-facing string (schema name, section titles,
 * field labels/descriptions/placeholders, option labels, column headers)
 * either as a plain string or as a multilang map like { en, tr }.
 *
 * Rendering such an object as a React child throws (error #31), so every
 * consumer that *displays* a schema must run it through here first. The Form
 * Builder is the one exception — it edits the raw multilang values.
 *
 * Pass `lang` explicitly to re-resolve when the user switches language;
 * it defaults to whatever i18n is currently on.
 */
export function localizeFieldSchema(schema, lang) {
  if (!schema) return schema;
  const txt = (v) => getLocalized(v, lang || i18n.language);

  return {
    ...schema,
    name: txt(schema.name),
    description: txt(schema.description),
    sections: (schema.sections || []).map((s) => ({
      ...s,
      title: txt(s.title),
      fields: (s.fields || []).map((f) => ({
        ...f,
        label: txt(f.label),
        description: txt(f.description),
        placeholder: txt(f.placeholder),
        options: (f.options || []).map((o) => ({ ...o, label: txt(o.label) })),
      })),
      tableColumns: (s.tableColumns || []).map((c) => ({
        ...c,
        header: txt(c.header),
        options: (c.options || []).map((o) => ({ ...o, label: txt(o.label) })),
      })),
    })),
  };
}

// Back-compat alias — existing callers import this name.
export const sanitizeFieldSchema = localizeFieldSchema;
